<template>
  <div class="s-strip s-leaseitnow-apply-form">
    <div class="page-container">
      <Loader v-if="isLoading" display="absolute"></Loader>
      <Alert
        v-if="errorMsgs.length"
        type="danger"
        :messages="errorMsgs"></Alert>

      <div class="row">
        <div class="col-lg-12 col-xl-1 mb-10">
          <button
            type="button"
            class="btn btn-link btn-icon-start btn-back"
            @click="onClickGoBack">
            <i class="icon-arrow-long-left"></i>
            <small>{{ dictionary.buttonBackToConfigText }}</small>
          </button>
        </div>
        <div class="d-block d-lg-none">
          <div class="col-lg-5 col-xl-4 offset-lg-1">
            <div class="mb-40">
              <VehicleAsideAccordion v-if="carObj" :car-obj="carObj">
                <VehicleAside :car-obj="carObj" />
              </VehicleAsideAccordion>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-xl-5 offset-xl-1">
          <ApplyResponse
            v-if="showResponse"
            :car-obj="carObj"
            :offer-pdf="offerpdf"
            :details-pdf="detailspdf" />
          <form v-else autocomplete="off" @submit.prevent="onSubmit">
            <div class="h2 mb-8">{{ dictionary.applyFormTitle }}</div>

            <div class="semibold small mb-24">
              {{ dictionary.applyFormSubTitle }}
            </div>

            <!-- company type -->
            <div class="mb-30">
              <label for="companyType" class="form-label">
                {{ dictionary.companyTypeLabel }}
              </label>

              <select
                id="companyType"
                v-model="companyType"
                name="companyType"
                class="form-select"
                :class="{ 'has-error': v$.companyType.$error }"
                @change="onChangeCompanyType">
                <option value="">
                  {{ dictionary.companyTypePlaceholder }}
                </option>
                <option
                  v-for="item in companyTypes"
                  :key="item.value"
                  :value="item.value">
                  {{ item.text }}
                </option>
              </select>

              <div v-if="v$.companyType.$error">
                <div v-if="v$.companyType.required.$invalid" class="error">
                  {{ dictionary.companyTypeRequired }}
                </div>
              </div>
            </div>

            <!-- company name -->
            <div v-if="hasExtraField" class="mb-30">
              <label for="companyName" class="form-label">
                {{ dictionary.companyNameLabel }}
              </label>
              <input
                id="companyName"
                v-model.trim="companyName"
                class="form-control"
                :class="{ 'has-error': v$.companyName.$error }"
                name="nacompanyNameme"
                type="text"
                @blur="v$.companyName.$touch" />

              <div v-if="v$.companyName.$error">
                <div v-if="v$.companyName.required.$invalid" class="error">
                  {{ dictionary.companyNameRequired }}
                </div>
                <div v-if="v$.companyName.minLength.$invalid" class="error">
                  {{ dictionary.companyNameLength }}
                </div>
              </div>
            </div>

            <!-- name -->
            <div class="mb-30">
              <label for="name" class="form-label">
                {{ dictionary.nameLabel }}
              </label>
              <input
                id="name"
                v-model.trim="name"
                class="form-control"
                :class="{ 'has-error': v$.name.$error }"
                name="name"
                type="text"
                @blur="v$.name.$touch" />

              <div v-if="v$.name.$error">
                <div v-if="v$.name.required.$invalid" class="error">
                  {{ dictionary.nameRequired }}
                </div>
                <div v-if="v$.name.minLength.$invalid" class="error">
                  {{ dictionary.nameLength }}
                </div>
              </div>
            </div>

            <!-- surname -->
            <div class="mb-30">
              <label for="surname" class="form-label">
                {{ dictionary.surnameLabel }}
              </label>
              <input
                id="surname"
                v-model.trim="surname"
                class="form-control"
                :class="{ 'has-error': v$.surname.$error }"
                name="surname"
                type="text"
                @blur="v$.surname.$touch" />

              <div v-if="v$.surname.$error">
                <div v-if="v$.surname.required.$invalid" class="error">
                  {{ dictionary.surnameRequired }}
                </div>
                <div v-if="v$.surname.minLength.$invalid" class="error">
                  {{ dictionary.surnameLength }}
                </div>
              </div>
            </div>

            <!-- email -->
            <div class="mb-30">
              <label for="email" class="form-label">
                {{ dictionary.emailLabel }}
              </label>
              <input
                id="email"
                v-model.trim="email"
                class="form-control"
                :class="{ 'has-error': v$.email.$error }"
                name="email"
                type="email"
                @blur="v$.email.$touch"
                @input="onInputEmail" />

              <div v-if="v$.email.$error">
                <div v-if="v$.email.required.$invalid" class="error">
                  {{ dictionary.emailRequired }}
                </div>
                <div v-if="v$.email.email.$invalid" class="error">
                  {{ dictionary.emailRegex }}
                </div>
              </div>
            </div>

            <!-- confirmEmail -->
            <div class="mb-30">
              <label for="confirmEmail" class="form-label">
                {{ dictionary.confirmEmailLabel }}
              </label>
              <input
                id="confirmEmail"
                v-model.trim="confirmEmail"
                class="form-control"
                :class="{ 'has-error': v$.confirmEmail.$error }"
                name="confirmEmail"
                type="text"
                @blur="v$.confirmEmail.$touch"
                @paste.prevent />

              <div v-if="v$.confirmEmail.$error">
                <div v-if="v$.confirmEmail.required.$invalid" class="error">
                  {{ dictionary.emailRequired }}
                </div>
                <div v-if="v$.confirmEmail.email.$invalid" class="error">
                  {{ dictionary.emailRegex }}
                </div>
                <div
                  v-if="v$.confirmEmail.sameAsPassword.$invalid"
                  class="error">
                  {{ dictionary.confirmEmailSameAs }}
                </div>
              </div>
            </div>

            <!-- terms -->
            <div class="mb-20">
              <div class="form-check">
                <input
                  id="leaseitnow-apply-form-accept-terms"
                  v-model="terms"
                  name="AcceptTerms"
                  type="checkbox"
                  class="form-check-input"
                  :class="{ 'has-error': v$.terms.$error }"
                  autocomplete="off" />
                <label
                  class="form-check-label"
                  for="leaseitnow-apply-form-accept-terms">
                  <div v-html="dictionary.termsLabel"></div>
                </label>
              </div>

              <div v-if="v$.terms.$error">
                <div v-if="v$.terms.checked.$invalid" class="error">
                  {{ dictionary.termsRequired }}
                </div>
              </div>
            </div>

            <!-- captcha -->
            <div class="mb-20">
              <div id="g-recaptcha"></div>

              <div v-if="v$.reCaptchaResponse.$error">
                <div
                  v-if="v$.reCaptchaResponse.required.$invalid"
                  class="error">
                  {{ dictionary.reCaptchaRequired }}
                </div>
              </div>
            </div>

            <button type="submit" class="btn btn-primary btn-full-width">
              {{ dictionary.buttonSubmitText }}
            </button>
          </form>
        </div>

        <div class="col-lg-5 col-xl-4 offset-lg-1">
          <div class="d-none d-lg-block">
            <VehicleAside v-if="carObj" :car-obj="carObj" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import * as lib from '../../lib/lib'
import useVuelidate from '@vuelidate/core'
import constants from './../../lib/constants'
import {
  email,
  minLength,
  required,
  requiredIf,
  sameAs,
} from '@vuelidate/validators'
import Alert from '../components/common/Alert.vue'
import Loader from '../components/common/Loader.vue'
import VehicleAside from './../components/leaseitnow/VehicleAside.vue'
import VehicleAsideAccordion from './../components/leaseitnow/VehicleAsideAccordion.vue'
import ApplyResponse from './../components/leaseitnow/ApplyResponse.vue'
import mixinsLeaseItNow from './../mixins/leaseitnow-mixins'

export default {
  components: {
    Alert,
    Loader,
    VehicleAside,
    VehicleAsideAccordion,
    ApplyResponse,
  },
  mixins: [mixinsLeaseItNow],
  beforeRouteLeave() {
    lib.removeURLParameter('page')
    this.showHeaderRequestOfferButton()

    const { sessionStorageConfig } = constants.leaseitnow
    sessionStorage.removeItem(sessionStorageConfig)

    this.setField({ field: 'extrasOptionIds', value: [] })
    this.setField({ field: 'extras', value: 0 })
    this.setField({ field: 'buyback', value: false })
  },
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      showResponse: false,
      scrollOffsetY: 125,
      isLoading: false,
      errorMsgs: [],

      // fields
      companyType: '',
      companyName: '',
      name: '',
      surname: '',
      email: '',
      confirmEmail: '',
      terms: false,
      reCaptchaResponse: '',
      reCaptchaWidget: null,
      // sources
      companyTypes: [],
      carObj: null,
      // response
      offerpdf: null,
      detailspdf: null,
      sessionStorageConfig: '',
    }
  },
  validations() {
    return {
      companyType: { required },
      companyName: {
        required: requiredIf(this.hasExtraField),
        minLength: minLength(3),
      },
      name: { required, minLength: minLength(3) },
      surname: { required, minLength: minLength(3) },
      email: { required, email },
      confirmEmail: { required, email, sameAsPassword: sameAs(this.email) },
      terms: { checked: (value) => value === true },
      reCaptchaResponse: { required },
    }
  },
  computed: {
    companyTypeText() {
      const entry = this.companyTypes.find((x) => x.value === this.companyType)
      return entry ? entry.text : ''
    },

    hasExtraField() {
      const entry = this.companyTypes.find((x) => x.value === this.companyType)
      return entry ? entry.extraFields : false
    },
  },
  mounted() {
    const { sessionStorageConfig } = constants.leaseitnow
    this.sessionStorageConfig = sessionStorageConfig

    if (!sessionStorage.getItem(this.sessionStorageConfig)) {
      const { language } = this.$route.params
      const url = window.location.href.split('/')

      this.$router.push({
        name: 'car',
        params: {
          language,
          slug: url[url.length - 2],
          id: url[url.length - 1],
        },
      })
      return
    }

    this.hideHeaderRequestOfferButton()

    const { companyTypes } = lib.getData('leaseItNowData')
    this.companyTypes = companyTypes

    this.setPreselctedValues()
    this.getCar()

    this.iniReCaptcha()

    document.addEventListener('recaptcha-ready', () => {
      if (this.reCaptchaWidget === null) {
        this.iniReCaptcha()
      }
    })
  },
  methods: {
    setPreselctedValues() {
      if (!sessionStorage.getItem(this.sessionStorageConfig)) {
        return
      }
      const carConfig = JSON.parse(
        sessionStorage.getItem(this.sessionStorageConfig)
      )

      this.setField({ field: 'deposit', value: carConfig.deposit })
      this.setField({
        field: 'extrasOptionIds',
        value: carConfig.extrasOptionIds,
      })
      this.setField({ field: 'numOfPayments', value: carConfig.numOfPayments })
      this.setField({ field: 'annualKm', value: carConfig.annualKm })
      this.setField({ field: 'buybackAmount', value: carConfig.buyback })
      this.setField({ field: 'extras', value: carConfig.extras })
      this.setField({ field: 'buyback', value: carConfig.buybackActive })
      this.setField({ field: 'vatIncluded', value: carConfig.vatIncluded })
    },

    getCar() {
      this.isLoading = true

      const { endpointGetCar } = this.configuration
      const { slug } = this.$route.params
      const url = `${endpointGetCar}/${this.getTypeToken()}/${slug}/`

      axios
        .get(url)
        .then((response) => {
          const { hasError, errorMessage } = response.data

          if (hasError) {
            this.handleError([errorMessage])
            return false
          }

          const { car } = response.data
          this.carObj = car

          this.handleSuccess()
          this.getRental()
        })
        .catch((errors) => {
          this.handleError([this.dictionary.defaultErrorMessage])
          console.error(errors)
        })
    },

    getRental() {
      this.isLoading = true

      const { id } = this.$route.params

      const postData = {
        car: id,
        deposit: this.deposit,
        extras: this.extras,
        extrasOptionIds: this.extrasOptionIds,
        numOfPayments: this.numOfPayments,
        annualKm: this.annualKm,
        buyback: this.buybackAmount,
        // eslint-disable-next-line camelcase
        buyback_active: this.buyback,
      }
      axios
        .post(this.configuration.endpointGetCarRental, postData)
        .then((response) => {
          const { hasError, errorMessage } = response.data

          if (hasError) {
            this.handleError([errorMessage])
            return false
          }

          // eslint-disable-next-line camelcase
          const { rentalPrice, vat, FinalPrice, extra_price } = response.data

          this.setField({ field: 'rentalPrice', value: rentalPrice })
          this.setField({ field: 'vat', value: vat })
          this.setField({ field: 'finalPrice', value: FinalPrice })
          // eslint-disable-next-line camelcase
          this.setField({ field: 'extraPrice', value: extra_price })
          this.handleSuccess()
        })
        .catch((errors) => {
          this.handleError([this.dictionary.defaultErrorMessage])
          console.error(errors)
        })
    },

    onClickGoBack() {
      this.$router.push({
        name: 'car',
        query: { hasExtrasArgs: true, hasRentalArgs: true },
      })

      lib.scrollToTop()
    },

    onChangeCompanyType() {
      this.companyName = ''
    },

    callbackReCaptcha(response) {
      this.reCaptchaResponse = response
    },

    expiredCallbackReCaptha() {
      this.reCaptchaResponse = ''
    },

    iniReCaptcha() {
      document.getElementById('g-recaptcha').innerHTML = ''

      const grecaptcha = window.grecaptcha

      if (grecaptcha && grecaptcha.render) {
        this.reCaptchaWidget = grecaptcha.render('g-recaptcha', {
          sitekey: this.configuration.reCaptchaPublicKey,
          callback: this.callbackReCaptcha,
          'expired-callback': this.expiredCallbackReCaptha,
        })
      }
    },

    resetReCaptcha() {
      this.reCaptchaResponse = ''
      window.grecaptcha.reset()
    },

    onSubmit() {
      this.v$.$validate()

      if (this.v$.$invalid) {
        this.$nextTick(() => {
          lib.scrollToValidation(this.scrollOffsetY)
        })
        return false
      }

      this.isLoading = true

      const { id } = this.$route.params

      const formData = new FormData()

      formData.append('vehicle_id', id)
      formData.append('numOfPayments', this.numOfPayments)
      formData.append('deposit', this.deposit)
      formData.append('buyback', this.buybackAmount)
      formData.append('buyback_active', this.buyback)
      formData.append('selectedKm', this.annualKm)
      formData.append('extrasPrice', this.extras)
      formData.append('extras', this.extrasOptionIds)
      formData.append('client_type', this.companyTypeText)
      formData.append('company_name', this.companyName)
      formData.append('first_name', this.name)
      formData.append('last_name', this.surname)
      formData.append('email', this.email)
      formData.append('channel', constants.leaseitnow.channel)

      axios
        .post(this.configuration.endpointSubmitData, formData)
        .then((response) => {
          const { hasError, errorMessage } = response.data

          if (hasError) {
            this.handleError([errorMessage])
            return false
          }

          const { lead } = response.data
          const { offerpdf, detailspdf } = lead
          this.offerpdf = offerpdf
          this.detailspdf = detailspdf

          this.handleSuccess()
          this.showResponse = true
          lib.appendUrlParam('page', 'success-leaseitnow')

          const { sessionStorageConfig } = constants.leaseitnow
          sessionStorage.removeItem(sessionStorageConfig)
        })
        .catch((errors) => {
          this.handleError([this.dictionary.defaultErrorMessage])
          console.error(errors)
        })
    },

    handleSuccess() {
      this.isLoading = false
      this.errorMsgs = []

      this.$nextTick(() => {
        lib.scrollToTop()
      })
    },

    handleError(messages) {
      this.errorMsgs = messages
      this.isLoading = false

      this.$nextTick(() => {
        lib.scrollToError(150)
      })
    },
  },
}
</script>
